import { useEffect, useState } from 'react';
import { getSubjectsList } from 'services/api';
import type { Subject } from './types';
import { transformSubjectsToOptions } from '../lib';

export const useFormService = () => {
  const [subjects, setSubject] = useState<Subject[]>([]);
  const [subjectIsLoading, setSubjectIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const loadSubjects = async () => {
      setSubjectIsLoading(true);
      try {
        const data = await getSubjectsList();

        setSubject(transformSubjectsToOptions(data.content));
      } finally {
        setSubjectIsLoading(false);
      }
    };

    loadSubjects();
  }, []);

  return {
    state: { subjects, subjectIsLoading },
  };
};
